export const VARIABLE_MODAL_KEY = 'variableModal';
